import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const WORDMARK = "https://customer-assets.emergentagent.com/job_executive-transform-3/artifacts/o3iwui7g_wordmark.jpg";

const links = [
  { to: "/career-journey", label: "Career Journey" },
  { to: "/accelerators", label: "Accelerators" },
  { to: "/enterprise", label: "Enterprise" },
  { to: "/philosophy", label: "Our Philosophy" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <>
      <header
        data-testid="site-nav"
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 bg-black text-white ${scrolled ? "border-b border-white/10" : ""}`}
      >
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" data-testid="brand-logo" className="flex items-center group" aria-label="kedve home">
            <img
              src={WORDMARK}
              alt="kedve"
              className="h-9 md:h-10 w-auto object-contain"
              style={{ mixBlendMode: "screen" }}
              draggable="false"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.to.replace("/", "")}`}
                className={({ isActive }) =>
                  `text-[13px] tracking-wide link-underline text-white ${isActive ? "opacity-100" : "opacity-70 hover:opacity-100"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-login"
              className="hidden md:inline-flex text-[13px] tracking-wide text-white opacity-70 hover:opacity-100 transition"
            >
              Login
            </button>
            <Link
              to="/apply"
              data-testid="nav-apply"
              className="hidden md:inline-flex items-center gap-2 bg-white text-black text-[13px] tracking-wide rounded-full px-5 py-2.5 hover:bg-white/90 transition"
            >
              Apply
            </Link>
            <button
              data-testid="nav-menu-toggle"
              className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-white"
              onClick={() => setOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile drawer */}
      <div
        data-testid="mobile-menu"
        className={`fixed inset-0 z-40 bg-black text-white transition-opacity duration-500 lg:hidden ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      >
        <div className="pt-24 px-8 flex flex-col gap-6">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.to.replace("/", "")}`}
              className="font-serif text-4xl tracking-tighter text-white"
            >
              {l.label}
            </Link>
          ))}
          <div className="mt-8 flex flex-col gap-3">
            <button className="text-sm tracking-wide text-left text-white opacity-70">Login</button>
            <Link to="/apply" className="inline-flex bg-white text-black rounded-full px-6 py-3 text-sm w-fit">
              Apply
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
